export enum SupportedLayout {
  Dagre = "dagre",
}
